import { TIME_DURATION } from '../../../../lib/MomentHelper'
import { LISTING_TYPE } from '../constants/listing'
import { CARRIER } from '../constants/carrier'
import { REFERRAL_TYPE } from '../constants/referralType'
import { TAB } from './PageViewsAnalysis'

export const GA_CLICK_ACTION = {
  TAB: 'TAB',
  DAILY_COMPARISON_RANGE: 'DAILY_COMPARISON_RANGE',
  DAILY_LISTING_OPTION: 'DAILY_LISTING_OPTION',
  DAILY_CARRIERS: 'DAILY_CARRIERS',
  DAILY_CHART_GROUP: 'DAILY_CHART_GROUP',
  DAILY_EXPORT_EXCEL: 'DAILY_EXPORT_EXCEL',
  SOURCE_COMPARISON_RANGE: 'SOURCE_COMPARISON_RANGE',
  SOURCE_LISTING_OPTION: 'SOURCE_LISTING_OPTION',
  SOURCE_CARRIERS: 'SOURCE_CARRIERS',
  SOURCE_REFERRAL_TYPE: 'SOURCE_REFERRAL_TYPE',
  SOURCE_EXPORT_EXCEL: 'SOURCE_EXPORT_EXCEL'
}

const GA_KEY = {
  TAB_DAILY: 'TAB_DAILY',
  TAB_SOURCE: 'TAB_SOURCE',
  DAILY_COMPARISON_RANGE: 'DAILY_COMPARISON_RANGE',
  DAILY_LISTING_OPTION_ALL: 'DAILY_LISTING_OPTION_ALL',
  DAILY_LISTING_OPTION_ORDER: 'DAILY_LISTING_OPTION_ORDER',
  DAILY_CARRIERS_ALL: 'DAILY_CARRIERS_ALL',
  DAILY_CARRIERS_APP: 'DAILY_CARRIERS_APP',
  DAILY_CARRIERS_MOBILE_WEB: 'DAILY_CARRIERS_MOBILE_WEB',
  DAILY_CARRIERS_DESKTOP_WEB: 'DAILY_CARRIERS_DESKTOP_WEB',
  DAILY_CARRIERS_UNKNOWN: 'DAILY_CARRIERS_UNKNOWN',
  DAILY_CHART_GROUP_DAY: 'DAILY_CHART_GROUP_DAY',
  DAILY_CHART_GROUP_WEEK: 'DAILY_CHART_GROUP_WEEK',
  DAILY_CHART_GROUP_MONTH: 'DAILY_CHART_GROUP_MONTH',
  DAILY_EXPORT_EXCEL: 'DAILY_EXPORT_EXCEL',
  SOURCE_COMPARISON_RANGE: 'SOURCE_COMPARISON_RANGE',
  SOURCE_LISTING_OPTION_ALL: 'SOURCE_LISTING_OPTION_ALL',
  SOURCE_LISTING_OPTION_ORDER: 'SOURCE_LISTING_OPTION_ORDER',
  SOURCE_CARRIERS_ALL: 'SOURCE_CARRIERS_ALL',
  SOURCE_CARRIERS_MOBILE_WEB: 'SOURCE_CARRIERS_MOBILE_WEB',
  SOURCE_CARRIERS_DESKTOP_WEB: 'SOURCE_CARRIERS_DESKTOP_WEB',
  SOURCE_REFERRAL_TYPE_INTERNAL: 'SOURCE_REFERRAL_TYPE_INTERNAL',
  SOURCE_REFERRAL_TYPE_EXTERNAL: 'SOURCE_REFERRAL_TYPE_EXTERNAL',
  SOURCE_EXPORT_EXCEL: 'SOURCE_EXPORT_EXCEL'
}

const GA_KEY_MAP = {
  [GA_KEY.TAB_DAILY]: 'pv_daytab',
  [GA_KEY.TAB_SOURCE]: 'pv_sourcetab',
  [GA_KEY.DAILY_COMPARISON_RANGE]: 'pv_day_compare',
  [GA_KEY.DAILY_LISTING_OPTION_ALL]: 'pv_day_allgd',
  [GA_KEY.DAILY_LISTING_OPTION_ORDER]: 'pv_day_specgd',
  [GA_KEY.DAILY_CARRIERS_ALL]: 'pv_day_deviceall',
  [GA_KEY.DAILY_CARRIERS_APP]: 'pv_day_app',
  [GA_KEY.DAILY_CARRIERS_MOBILE_WEB]: 'pv_day_mobileweb',
  [GA_KEY.DAILY_CARRIERS_DESKTOP_WEB]: 'pv_day_desktopweb',
  [GA_KEY.DAILY_CARRIERS_UNKNOWN]: 'pv_day_deviceother',
  [GA_KEY.DAILY_CHART_GROUP_DAY]: 'pv_day_showday',
  [GA_KEY.DAILY_CHART_GROUP_WEEK]: 'pv_day_showweek',
  [GA_KEY.DAILY_CHART_GROUP_MONTH]: 'pv_day_showmonth',
  [GA_KEY.DAILY_EXPORT_EXCEL]: 'pv_day_downloadfile',
  [GA_KEY.SOURCE_COMPARISON_RANGE]: 'pv_source_compare',
  [GA_KEY.SOURCE_LISTING_OPTION_ALL]: 'pv_source_allgd',
  [GA_KEY.SOURCE_LISTING_OPTION_ORDER]: 'pv_source_specgd',
  [GA_KEY.SOURCE_CARRIERS_ALL]: 'pv_source_deviceall',
  [GA_KEY.SOURCE_CARRIERS_MOBILE_WEB]: 'pv_source_mobileweb',
  [GA_KEY.SOURCE_CARRIERS_DESKTOP_WEB]: 'pv_source_desktopweb',
  [GA_KEY.SOURCE_REFERRAL_TYPE_INTERNAL]: 'pv_source_internal',
  [GA_KEY.SOURCE_REFERRAL_TYPE_EXTERNAL]: 'pv_source_external',
  [GA_KEY.SOURCE_EXPORT_EXCEL]: 'pv_source_downloadfile'
}

export const getI13nModel = (action = {}, customizeI13nModel = {}) => {
  const { type, payload } = action
  let key
  switch (type) {
    case GA_CLICK_ACTION.TAB: {
      const map = {
        [TAB.DAILY]: GA_KEY.TAB_DAILY,
        [TAB.SOURCE]: GA_KEY.TAB_SOURCE
      }
      key = map[payload]
      break
    }
    case GA_CLICK_ACTION.DAILY_LISTING_OPTION:
    case GA_CLICK_ACTION.SOURCE_LISTING_OPTION: {
      const dailyMap = {
        [LISTING_TYPE.ALL]: GA_KEY.DAILY_LISTING_OPTION_ALL,
        [LISTING_TYPE.ORDER]: GA_KEY.DAILY_LISTING_OPTION_ORDER
      }
      const sourceMap = {
        [LISTING_TYPE.ALL]: GA_KEY.SOURCE_LISTING_OPTION_ALL,
        [LISTING_TYPE.ORDER]: GA_KEY.SOURCE_LISTING_OPTION_ORDER
      }
      const map = (type === GA_CLICK_ACTION.DAILY_LISTING_OPTION)
        ? dailyMap
        : sourceMap
      key = map[payload]
      break
    }
    case GA_CLICK_ACTION.DAILY_CARRIERS:
    case GA_CLICK_ACTION.SOURCE_CARRIERS: {
      const dailyMap = {
        [CARRIER.ALL]: GA_KEY.DAILY_CARRIERS_ALL,
        [CARRIER.APP]: GA_KEY.DAILY_CARRIERS_APP,
        [CARRIER.MOBILE_WEB]: GA_KEY.DAILY_CARRIERS_MOBILE_WEB,
        [CARRIER.DESKTOP_WEB]: GA_KEY.DAILY_CARRIERS_DESKTOP_WEB,
        [CARRIER.UNKNOWN]: GA_KEY.DAILY_CARRIERS_UNKNOWN
      }
      const sourceMap = {
        [CARRIER.ALL]: GA_KEY.SOURCE_CARRIERS_ALL,
        [CARRIER.MOBILE_WEB]: GA_KEY.SOURCE_CARRIERS_MOBILE_WEB,
        [CARRIER.DESKTOP_WEB]: GA_KEY.SOURCE_CARRIERS_DESKTOP_WEB
      }
      const map = (type === GA_CLICK_ACTION.DAILY_CARRIERS)
        ? dailyMap
        : sourceMap
      key = map[payload]
      break
    }
    case GA_CLICK_ACTION.DAILY_CHART_GROUP: {
      const map = {
        [TIME_DURATION.DAY.value]: GA_KEY.DAILY_CHART_GROUP_DAY,
        [TIME_DURATION.WEEK.value]: GA_KEY.DAILY_CHART_GROUP_WEEK,
        [TIME_DURATION.MONTH.value]: GA_KEY.DAILY_CHART_GROUP_MONTH
      }
      key = map[payload]
      break
    }
    case GA_CLICK_ACTION.SOURCE_REFERRAL_TYPE: {
      const map = {
        [REFERRAL_TYPE.INTERNAL]: GA_KEY.SOURCE_REFERRAL_TYPE_INTERNAL,
        [REFERRAL_TYPE.EXTERNAL]: GA_KEY.SOURCE_REFERRAL_TYPE_EXTERNAL
      }
      key = map[payload]
      break
    }
    case GA_CLICK_ACTION.DAILY_COMPARISON_RANGE:
    case GA_CLICK_ACTION.SOURCE_COMPARISON_RANGE:
    case GA_CLICK_ACTION.DAILY_EXPORT_EXCEL:
    case GA_CLICK_ACTION.SOURCE_EXPORT_EXCEL:
      key = GA_KEY[type]
      break
    default:
      break
  }
  const i13nModel = {
    label: GA_KEY_MAP[key],
    ...customizeI13nModel
  }
  return i13nModel
}
